var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.cssClass,attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c(_vm.type,{tag:"component",attrs:{"fill":_vm.fill}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }